// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"422":"6ab612aeca","748":"5d36c537ac"}[chunkId] + ".js";
};